export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 44 44" className={className} role="img" aria-label="Directelabels logo">
      <defs>
        <linearGradient id="dl-logo-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#00A85A" />
          <stop offset="1" stopColor="#009951" />
        </linearGradient>
      </defs>
      <rect width="44" height="44" rx="12" fill="url(#dl-logo-gradient)" />
      <path
        d="M11.5 22.5 22 13l10.5 9.5"
        fill="none"
        stroke="#fff"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M23.2 17.8 18.6 24.4h3.2L19.6 31l7.4-8.9h-3.2l3-4.3z" fill="#fff" />
    </svg>
  );
}

export default function Logo({ dark = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      <span className="font-display leading-none">
        <span className={`block text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-ink"}`}>
          Directelabels
        </span>
        <span className={`block text-[10px] font-medium uppercase tracking-[0.14em] ${dark ? "text-white/60" : "text-primary"}`}>
          Energielabels voor woningen
        </span>
      </span>
    </span>
  );
}
